import { confirmationConstants } from '../constants'

const defaultState = {
    data: [{}],
  }

export default function confirmation(state = defaultState, action){
    switch(action.type) {
        case confirmationConstants.CONFIRMATION_SELECTED:
            return { ...state, ...action }
        default:
            return { ...state }
    }
}